// Lecture des montants saisis dans les champs texte des lois de roulage.
// `parseFloat` seul transformait une virgule décimale en troncature silencieuse
// ("21,66" -> 21) et un champ vidé en NaN, qui ramenait tout le loyer à 0.
const ESPACES = /[\s  ]/g;

const normaliserSaisieMontant = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(ESPACES, "").replace(",", ".");
};

// NaN pour une saisie vide ou non numérique : c'est à l'appelant de décider
// si le champ est optionnel (0) ou obligatoire (à signaler).
const lireMontant = (value) => {
  if (typeof value === "number") return value;
  if (typeof value !== "string") return NaN;
  const normalise = normaliserSaisieMontant(value);
  return normalise === "" ? NaN : Number(normalise);
};

const estVide = (value) =>
  value === null ||
  value === undefined ||
  (typeof value === "string" && value.trim() === "");

// Option facultative (prévoyance, sérénité, véhicule relais, apport) :
// un champ vidé veut dire « aucune », donc 0.
const lireMontantOptionnel = (value) =>
  estVide(value) ? 0 : lireMontant(value);

const montantTools = {
  normaliserSaisieMontant,
  lireMontant,
  lireMontantOptionnel,
  estVide,
};

export default montantTools;
